

import styled from "styled-components"
import buttonShare from '@/img/value-investment/share.png'
export const Footer = styled.div`
// position: fixed;
// left: 0;
// right: 0;
height: 78px;
margin-top: 10px;
// bottom: -88px;
background-color: rgba(242,63,86, .2);
backdrop-filter: blur(7px);
padding: 0 19px;
z-index: 10;
transition: bottom 0.5s;
&.footer-freeclass-block {
    bottom: 0;
}
.desc {
  font-size: 12px;
  color: #eee;
  height: 22px;
  // line-height: 29px;
  text-align: center;
}
.buttons {
  display: flex;
  justify-content: space-between;
}
.button {
  width: 110px;
  height: 42px;
  background-image: url(${buttonShare});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  line-height: 16px;
  justify-content: center;
  .button-icon {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }
  .button-content {
    color: #c65c00;
    font-size: 12px;
  }
}
`


// WEBPACK FOOTER //
// ./src/views/activity_50/Footer/style.js